import TeaserTitle from '#components/common/teaser-meta/TeaserTitle';
import TeaserDetailsMeta from '#components/teaser-details/TeaserDetailsMeta';
import Typography from '#components/typography/Typography';
import React from 'react';

type Props = {
  teaserData: {
    title?: string;
    categories?: { title: string }[];
    fskRating?: string;
    year?: number;
    mediaDuration?: number;
    teaserDescription?: string;
    shortDescription?: string;
  };
};

const TeaserDetailsMediaInfos = ({ teaserData }: Props) => {
  return (
    <>
      <TeaserTitle size="medium" lines={2}>
        {teaserData.title}
      </TeaserTitle>
      {!!teaserData && (
        <TeaserDetailsMeta
          categories={teaserData.categories}
          fskRating={teaserData.fskRating}
          year={teaserData.year}
          duration={teaserData.mediaDuration || 0}
        />
      )}
      <Typography classes="tw-line-clamp-3 tw-mb-3">
        {teaserData?.teaserDescription}
      </Typography>
    </>
  );
};

export default TeaserDetailsMediaInfos;
